module.exports = __webpack_public_path__ + "static/media/ua_genelife.099163bf.png";